import { ActionType, createAction } from 'typesafe-actions';

export const fetchAnnotationStackFulfilled = createAction(
  'FETCH_ANNOTATION_STACK_FULFILLED',
  (payload: number[]) => payload
)<number[]>();

export type StackActions = ActionType<typeof fetchAnnotationStackFulfilled>;
